const initialState = {
  invoices: [],
  InvRptDta: [],
  PerfomaInvDta: [],
  loading: false,
  actionLoading: false,
  printLoading: false,
  perfomaInvLoading: false,
  error: null
};

const InvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_INVOICES_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_INVOICES_SUCCESS':
      return { ...state, loading: false, invoices: action.payload, error: null };

    case 'FETCH_INVOICES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GENERATE_INVOICES_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'GENERATE_INVOICES_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        invoices: [action.payload, ...state.invoices],
        error: null
      };

    case 'GENERATE_INVOICES_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'PRINT_INVOICE_REQUEST':
      return { ...state, printLoading: true, error: null };

    case 'PRINT_INVOICE_SUCCESS':
      return {
        ...state,
        printLoading: false,
        InvRptDta: action.payload,
        error: null
      };

    case 'PRINT_INVOICE_FAILURE':
      return {
        ...state,
        printLoading: false,
        error: action.payload
      };
    case 'GENERATE_PERFOMA_INV_REQUEST':
      return { ...state, perfomaInvLoading: true, error: null };

    case 'GENERATE_PERFOMA_INV_SUCCESS':
      return {
        ...state,
        perfomaInvLoading: false,
        PerfomaInvDta: action.payload,
        error: null
      };

    case 'GENERATE_PERFOMA_INV_FAILURE':
      return {
        ...state,
        perfomaInvLoaading: false,
        error: action.payload
      };

    case 'CLEAR_PRINT_INVOICE':
      return {
        ...state,
        InvRptDta: []
      };

    default:
      return state;
  }
};

export default InvoiceReducer;
